module.exports = __webpack_public_path__ + "img/3.d401ef2d.png";